let IDENTITY_POOL_ID = "us-west-2:31429034-758c-46e3-9630-a6ba90cfba00"
export default IDENTITY_POOL_ID